import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { getCmsLayout, useCmsStore } from "@/data/cmsStore";
import { useI18n } from "@/i18n/I18nProvider";

const ConditionsPage = () => {
  const { lang, isRtl } = useI18n();
  const layouts = useCmsStore(state => state.layouts);
  const layout = layouts["global"] || getCmsLayout("global");
  
  const [content, setContent] = useState<Record<string, string>>({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const legalSection = layout.find((s: any) => s.id === "legal_pages");
    if (legalSection && legalSection.content) {
      setContent(legalSection.content);
    }
  }, [layout]);

  const isVisible = content["conditions_visible"] !== "false";
  const title = content[`conditions_title_${lang}`] || content["conditions_title_fr"] || "Conditions d'utilisation";
  const htmlContent = content[`conditions_content_${lang}`] || content["conditions_content_fr"] || "";

  return (
    <div className="min-h-screen bg-background flex flex-col font-body" dir={isRtl ? "rtl" : "ltr"}>
      <Navbar />
      <main className="flex-1 container max-w-4xl px-4 py-24 md:py-32">
        <h1 className="text-4xl md:text-5xl font-display font-extrabold text-primary mb-12 text-center md:text-start">
          {title}
        </h1>

        <div className="bg-card border rounded-2xl p-6 md:p-12 shadow-sm">
          {!isVisible ? (
            <div className="text-center py-12 text-muted-foreground italic">
              {lang === 'ar' ? 'هذه الصفحة قيد الصيانة.' : lang === 'zgh' ? 'ⵜⴰⵙⵏⴰ ⴰⴷ ⵜⵍⵍⴰ ⴳ ⵓⵙⴳⴳⴷ.' : 'Cette page est en cours de maintenance.'}
            </div>
          ) : (
            <div 
              className="prose prose-lg dark:prose-invert max-w-none text-foreground/80 space-y-4"
              dangerouslySetInnerHTML={{ __html: htmlContent }} 
            />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ConditionsPage;
